<div #anchor>
	<span ultra-menu-item-wrapper>
		<button
			[disabled]="isEditMode()"
			(click)="showMenu($event)"
			ultra-menu-item
			content="shared|change-status"
			svgIcon="donut_large"></button>
	</span>
</div>
<ng-template #templateRef>
	<app-list-item-menu-container>
		<app-ultra-actions-navigation [navigationData]="menuData">
		</app-ultra-actions-navigation>
	</app-list-item-menu-container>
</ng-template>
